import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CheckCircle, Loader } from 'lucide-react';
import serviceManagementService from '../services/serviceManagementService';
import './PaymentResult.scss';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const purchaseId = searchParams.get('purchase_id');

  const [status, setStatus] = useState<string>('pending');
  const [serviceName, setServiceName] = useState<string>('');
  const [pricePaid, setPricePaid] = useState<number>(0);
  const [currency, setCurrency] = useState<string>('EUR');
  const [polling, setPolling] = useState(true);

  useEffect(() => {
    if (!purchaseId) return;

    let attempts = 0;
    const maxAttempts = 20;

    const poll = async () => {
      try {
        const result = await serviceManagementService.getPaymentStatus(Number(purchaseId));
        setStatus(result.status);
        setServiceName(result.service_name || '');
        setPricePaid(Number(result.price_paid) || 0);
        setCurrency(result.currency || 'EUR');

        if (result.status === 'completed' || result.status === 'failed') {
          setPolling(false);
          return;
        }

        attempts++;
        if (attempts >= maxAttempts) {
          setPolling(false);
          return;
        }

        setTimeout(poll, 2000);
      } catch {
        attempts++;
        if (attempts >= maxAttempts) {
          setPolling(false);
          return;
        }
        setTimeout(poll, 3000);
      }
    };

    poll();
  }, [purchaseId]);

  return (
    <div className="payment-result-page">
      <div className="container">
        <div className="result-card success">
          {polling && status === 'pending' ? (
            <>
              <div className="result-icon pending">
                <Loader size={64} className="spinner-icon" />
              </div>
              <h1>Tikrinamas mokėjimas...</h1>
              <p>Palaukite, kol patvirtinsime jūsų mokėjimą.</p>
            </>
          ) : status === 'completed' ? (
            <>
              <div className="result-icon">
                <CheckCircle size={64} />
              </div>
              <h1>Mokėjimas sėkmingas!</h1>
              <p>Jūsų užsakymas apdorotas sėkmingai.</p>
              
              {serviceName && (
                <div className="order-summary">
                  <div className="summary-item">
                    <span>{serviceName}</span>
                    <span>{pricePaid.toFixed(2)} {currency}</span>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <div className="result-icon">
                <CheckCircle size={64} />
              </div>
              <h1>Mokėjimas priimtas</h1>
              <p>Jūsų mokėjimas buvo priimtas. Užsakymo statusą galite stebėti paslaugų puslapyje.</p>
            </>
          )}

          <button
            className="btn-primary"
            onClick={() => navigate(user?.user_type === 'employer' ? '/employer/services?mode=employer' : '/employee/services')}
          >
            Grįžti į paslaugas
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
